import type { FieldValue } from './types';

interface MediaGroupNode {
  id: FieldValue;
  name: FieldValue;
}

interface PGroupMemberNode {
  mediaGroups: {
    edges: {
      node: MediaGroupNode;
    };
  };
}

interface MeNodeTypeResult {
  id: FieldValue;
  pgroupMembers: {
    edges: {
      node: PGroupMemberNode;
    };
  };
}

interface MeQueryResult {
  query: {
    me: MeNodeTypeResult;
  };
}

export const MeNodeType = (truify: boolean = false): MeNodeTypeResult => ({
  id: truify,
  pgroupMembers: {
    edges: {
      node: {
        mediaGroups: {
          edges: {
            node: {
              id: truify,
              name: truify,
            },
          },
        },
      },
    },
  },
});

export const meQuery = (truify: boolean = false): MeQueryResult => ({
  query: {
    me: {
      ...MeNodeType(truify),
    },
  },
});
